export default __webpack_public_path__ + "f8342fbf01f7879d7beae58f88c9fd0f.png";